export const handleMobileSize = (size, mobileScale) => {
  if (size) {
    const numericSize = parseFloat(size.replace(/[^0-9.]/g, ""))
    const sizeEnding = size.replace(/[0-9.]/g, "")
    let mobileSize = Math.round(numericSize * mobileScale * 10) / 10

    if (isNaN(mobileSize)) {
      return "inherit"
    }

    // Maybe let it go down to 0.9?
    if (mobileSize < 1.0) {
      mobileSize = 1.0
    }

    return mobileSize + sizeEnding
  } else {
    return 1.0
  }
}
